import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import ChapterLevelTabs from "./ChapterLevelTabs";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";

const ChapterLevel = ({ data }) => {
  return (
    <>
      <Card>
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {data.levelName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {data.stageInfo}
          </Typography>
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={0}
            >
               
               <Typography variant="h6">REC.{" "}</Typography>
               <Typography variant="h6">{data.recLv}</Typography>
            </Stack>
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={0}
            >
               
              <Avatar
                style={{
                  width: 50,
                  height: 40,
                  borderRadius: "5px",
                }}
                variant="square"
                alt="rarityIcons"
                src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637791789/RevivedWitch/Items/chest_icon_xlpguf.png"
              />
               <Typography variant="h6">{data.chestAvailable}</Typography>
            </Stack>
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={0}
            >
               
              <Avatar
                style={{
                  width: 50,
                  height: 40,
                  borderRadius: "5px",
                }}
                variant="square"
                alt="rarityIcons"
                src="https://res.cloudinary.com/dt8txlhs2/image/upload/v1637790182/RevivedWitch/Items/stamina_icon_ca4w6m.png"
              />
               <Typography variant="h6">{data.staminaCost}</Typography>
            </Stack>
          </Stack>
        </CardContent>
        <ChapterLevelTabs rewards={data.clearanceRewards} enemies={data.enemies}/>
      </Card>
    </>
  );
};

export default ChapterLevel;
